<template>
  <div>
    <div class="search-box gauge_20">
      <div class="form">

        <div class="input-item">
          <span class="label">图片名称</span>
          <Input v-model="searchObj.picName" placeholder="请输入" clearable />
        </div>

        <!-- <div class="input-item">
          <span class="label">内容标题</span>
          <Input v-model="searchObj.picTitle" placeholder="请输入" clearable />
        </div> -->

        <div class="input-item">
          <span class="label">有效期</span>
          <DatePicker
            :clearable="true"
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            v-model="searchObj.validDate"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </DatePicker>
        </div>
        <div class="input-item">
          <span class="label">展示机构</span>
          <selectTree type="3" v-model="searchObj.showOrgIds"></selectTree>
        </div>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="initBannerList">查询</Button>
        <Button @click="reset">重置</Button>
        <Button
          type="primary"
          class="add-btn"
          @click="$refs.bannerChange.open({})"
          >新增</Button
        >
      </div>
    </div>

    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="table-box setTable">
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="picName">
          <div>
            <a class="txt-ellipsis2" @click="$refs.bannerChange.open(row)" :title="row.picName">{{ row.picName }}</a>
          </div>          
        </template>

        <template slot-scope="{ row, index }" slot="mobilePic">
          <div class="img-box">
            <img :src="row.mobilePic" :preview="index" :key="row.mobilePic"/>
          </div>
        </template>

        <template slot-scope="{ row, index }" slot="pcPic">
          <div class="img-box">
            <img :src="row.pcPic" :preview="index" :key="row.pcPic"/>
          </div>
        </template>

        <template slot-scope="{ row }" slot="sort">
          <Input v-model="row.orderNum" :min="0" @on-blur='blurSort(row)' />
        </template>

        <template slot-scope="{ row }" slot="action">
          <div class="action-box">
            <div class="action-btn">
              <a @click="$refs.bannerChange.open(row)">编辑</a>
              <a @click="submitDelete(row)">删除</a>
            </div>
          </div>
        </template>
      </Table>
    </div>

    <div class="pageBox">
      <Page
        :total="total"
        :current="searchObj.pageNo"
        :page-size="searchObj.pageSize"
        show-total
        @on-change="pageChange"
        style="text-align: center"
      />
    </div>

    <!-- 新增-编辑 -->
    <advertisement-change ref="bannerChange" :initBannerList="initBannerList"></advertisement-change>
  </div>
</template>

<script>
import filters from "@/api/filter";
import selectTree from "@/components/system/selectTree3";
import advertisementChange from "./components/advertisementChange";
export default {
  name: "advertisementConfig",
  components: {
    selectTree,
    advertisementChange,
  },
  filters,
  data() {
    return {
      total: 0,
      searchObj: {
        pageNo: 1,
        pageSize: 10,
        configType: 3
      },
      organizationList: [],
      tableData: [],
      columns: [
        {
          title: "序号",
          type: "index",
          align: "center",
          minWidth:100,
        },
        {
          title: "图片名称",
          align: "center",
          minWidth:300,
          slot: "picName",
        },
        {
          title: "图片",
          align: "center",
          minWidth: 300,
          slot: "mobilePic",
        },
        {
          title: "排序",
          minWidth: 160,
          align: "center",
          slot: "sort",
        },
        {
          title: "有效期",
          minWidth: 250,
          align: "center",
          render(h, params) {
            const effectTimeStart = params.row.effectTimeStart;
            const effectTimeEnd = params.row.effectTimeEnd;
            let str = `${
              effectTimeStart && effectTimeEnd
                ? filters.filterTime(effectTimeStart, "YYYY-MM-DD") +
                  " 至 " +
                  filters.filterTime(effectTimeEnd, "YYYY-MM-DD")
                : "持续生效"
            }`;
            return <span>{str}</span>;
          },
        },
        {
          title: "创建时间",
          minWidth: 160,
          align: "center",
          render(h, params) {
            const result = params.row.createTime;
            return (
              <span>
                {filters.filterTime(result, "YYYY-MM-DD HH:mm") || "-"}
              </span>
            );
          },
        },
        {
          title: "操作",
          minWidth: 120,
          align: "center",
          slot: "action",
          fixed: "right"
        },
      ],
    };
  },
  created() {
    this.initBannerList();
  },
  methods: {
    // 处理请求参数
    setRequestParam() {
      let obj = JSON.parse(JSON.stringify(this.searchObj));
      if (obj.validDate && obj.validDate[0]) {
        obj.effectTimeStart = filters.filterTime(
          obj.validDate[0],
          "YYYY-MM-DD"
        );
        obj.effectTimeEnd = filters.filterTime(obj.validDate[1], "YYYY-MM-DD");
      }
      obj.showOrgIds = obj.showOrgIds?[obj.showOrgIds]:[];
      
      delete obj.validDate;
      let { ...params } = obj;
      return params;
    },

    // 查询
    initBannerList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/exhibitionPicConfig/read/list",
        type: "POST",
        data: this.setRequestParam(),
        apiPermissionCode:'operate_3_0'
      }).then((res) => {
        this.total = res.total;
        this.tableData = res.data;
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 重置
    reset() {
      this.searchObj = {
        pageNo: 1,
        pageSize: 10,
        configType: 3
      };
      this.initBannerList();
    },

    dealTree(arr) {
      return arr.map((item) => ({
        ...item,
        expand: item.nodeType === 1 ? true : false,
        value: item,
        label: item.name,
        children:
          item.children && item.children.length > 0
            ? this.dealTree(item.children)
            : null,
      }));
    },

    // 删除
    submitDelete(item) {
      this.$notice.inquiry("确认删除操作？").then(async () => {
        this.$http({
          url: `/buz/exhibitionPicConfig/del?id=${item.id}`,
          type: "GET",
          apiPermissionCode:'operate_3_2'
        }).then((res) => {
          this.$Message.success("删除成功");
          this.initBannerList();
        });
      });
    },

    // 排序
    blurSort(data) {
      let objRegExp = /^([1-9]\d*|[0]{1,1})$/;
      if(!objRegExp.test(data.orderNum)){
        this.$Message.error('请输入0或正整数');
        return
      }
      if(!data.orderNum)return;
      if(data.orderNum<0){
        data.orderNum=0;
      }
      this.$http({
        url: "/buz/exhibitionPicConfig/edit",
        type: "POST",
        data
      }).then((res) => {
        this.$notice.success('修改成功');
        this.initBannerList();
      })
    },

    // 分页
    pageChange(pageNo) {
      this.searchObj.pageNo = pageNo;
      this.initBannerList();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  .form {
    width: 95%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .input-item {
      display: flex;
      align-items: center;
      padding-right: 50px;
    }
    .label {
      min-width: 60px;
      font-size: 13px;
    }
    /deep/ .ivu-input {
      font-size: 13px;
    }
  }
  /deep/ .add-btn {
    background: #f59045 !important;
    border: none;
  }
  .btn-item {
    /deep/ .ivu-btn {
      font-size: 13px;
    }
  }
}
.setTable {
  .img-box {
    img {
      width: 35%;
    }
  }
  .pic-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .action-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    .action-btn {
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
.setTable {
  /deep/ .ivu-input {
    width: 100px;
    padding-right: 10px;
    text-align: center;
  }
}
/deep/ .setTable .ivu-table th .ivu-table-cell {
  font-size: 12px;
  font-weight: bold;
  color: #272933;
}
/deep/ .ivu-table-tip {
  font-size: 12px;
}
.pageBox {
  margin-top: 20px;
}
</style>